function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGruppe2962(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Gruppe 2962",
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 159.789,
    viewBox: "0 0 120 159.789",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "dsoxn0454a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rechteck 2571",
    style: {
      fill: "none"
    },
    d: "M0 0h120v159.789H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2961",
    style: {
      clipPath: "url(#dsoxn0454a)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2868",
    d: "M120.279 32.139A46.315 46.315 0 1 1 60.808 4.693a46.316 46.316 0 0 1 59.472 27.446",
    transform: "translate(-4.692 -.281)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2869",
    d: "M120.279 32.139A46.315 46.315 0 1 1 60.808 4.693a46.316 46.316 0 0 1 59.471 27.446z",
    transform: "translate(-4.692 -.281)",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: "3.649px",
      stroke: "#9ea1a2",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2870",
    d: "m119.931 46.28-2.689-7.234a1.285 1.285 0 0 0-1.651-.759l-4.767 1.757c-1.505-1.636-5.578-5.359-11.124-5.017l-.892-7.277a1.287 1.287 0 0 0-2.254-.681L89.3 35.543a34.528 34.528 0 0 0-9.168-.909 15.134 15.134 0 1 0-24.407 9.08c-.91.7-1.832 1.393-2.694 2.161a31.372 31.372 0 0 0-4.814 5.3c-1.787-.626-4.112-1.817-4.618-3.162a1.742 1.742 0 0 1 .322-1.688 1.635 1.635 0 0 1 1.713-.927 1.616 1.616 0 0 1 1.231 1.106c.02.1.063.356-.439.658l1.327 2.206a3.18 3.18 0 0 0 1.651-3.294 4.124 4.124 0 0 0-7.634-1.161 4.3 4.3 0 0 0-.578 4.015c.882 2.327 3.786 3.763 5.637 4.473a13.668 13.668 0 0 0-1.72 8.094c.822 7.044 7.488 11.368 9.053 12.293l8.86 14.677a1.287 1.287 0 0 0 1.1.621 1.255 1.255 0 0 0 .444-.08l9.87-3.637a1.28 1.28 0 0 0 .764-1.649l-1.676-4.548c3.438-.344 11.273-1.389 16.607-4.076l4.569 2.367a1.261 1.261 0 0 0 1.037.063l7.877-2.9a1.276 1.276 0 0 0 .746-.719 1.294 1.294 0 0 0-.027-1.037l-3.285-6.958c3.764-1.49 14.129-6.264 16.624-14.5l2.189-4.066a1.293 1.293 0 0 0 .073-1.058m-66.468-9.971a12.556 12.556 0 1 1 21.6 3.458 35.788 35.788 0 0 0-12.291 4.489 12.578 12.578 0 0 1-9.307-7.947M115.34 50.3a1.331 1.331 0 0 0-.1.251c-2.53 8.691-16.222 13.37-16.36 13.416a1.288 1.288 0 0 0-.756 1.771l3.282 6.956-6.026 2.221-4.658-2.415a1.289 1.289 0 0 0-1.211.015c-6.284 3.45-17.74 4.226-17.856 4.234a1.287 1.287 0 0 0-1.124 1.729l1.813 4.922-7.664 2.826-8.48-14.054a1.261 1.261 0 0 0-.49-.465c-.073-.041-7.279-4.005-8.038-10.509-.5-4.267 1.884-8.775 7.08-13.4 1.033-.921 2.127-1.771 3.23-2.593a15.23 15.23 0 0 0 2.018.922 31.826 31.826 0 0 0-2.78 2.3 1.286 1.286 0 0 0 1.757 1.873c9.837-9.229 22.765-8.47 22.909-8.453a1.321 1.321 0 0 0 1.369-1.2 1.284 1.284 0 0 0-1.19-1.372 28.783 28.783 0 0 0-3.65.077 15.051 15.051 0 0 0 .978-2.109 30.918 30.918 0 0 1 9.959.976 1.292 1.292 0 0 0 1.377-.387l5.882-6.878.694 5.649a1.286 1.286 0 0 0 1.505 1.11c6.1-1.113 10.556 4.563 10.6 4.621a1.279 1.279 0 0 0 1.465.422l4.4-1.621 2.037 5.485z",
    transform: "translate(-6.299 -2.592)",
    style: {
      fill: "#9ea1a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2871",
    d: "M111.37 45.384a2.115 2.115 0 1 0 2.715 1.253 2.115 2.115 0 0 0-2.715-1.253",
    transform: "translate(-16.925 -6.964)",
    style: {
      fill: "#9ea1a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2872",
    d: "m57.827 38.469 2.645-.975a8.868 8.868 0 0 0 3.75 3.23 9.679 9.679 0 0 0 12.154-3.858l-.794-2.157a7.832 7.832 0 0 1-4.711 4.775 7.677 7.677 0 0 1-8.864-2.554l9.757-3.6.1-1.7-10.676 3.937c-.113-.236-.243-.454-.337-.707s-.135-.5-.2-.756l11.288-4.159.073-1.69-11.62 4.281a7.676 7.676 0 0 1 5.086-7.695 8.042 8.042 0 0 1 6.663.523l.095-1.713a9.191 9.191 0 0 0-7.3-.275 9.054 9.054 0 0 0-5.324 4.835 8.874 8.874 0 0 0-.757 4.891l-2.006.739-.1 1.7 2.433-.9c.074.252.112.5.206.756s.226.47.334.709l-1.8.662z",
    transform: "translate(-8.733 -3.501)",
    style: {
      fill: "#9ea1a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2873",
    d: "M55.826 162.986A10.17 10.17 0 1 0 66 173.155a10.18 10.18 0 0 0-10.17-10.169",
    transform: "translate(-7.026 -25.081)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2874",
    d: "M55.826 162.986A10.17 10.17 0 1 0 66 173.155a10.18 10.18 0 0 0-10.174-10.169z",
    transform: "translate(-7.026 -25.081)",
    style: {
      stroke: "#3e4346",
      strokeMiterlimit: 10,
      strokeWidth: "3.649px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2875",
    d: "M95.917 162.986a10.17 10.17 0 1 0 10.17 10.169 10.181 10.181 0 0 0-10.17-10.169",
    transform: "translate(-13.195 -25.081)",
    style: {
      fill: "#c5d75d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2876",
    d: "M95.917 162.986a10.17 10.17 0 1 0 10.17 10.169 10.181 10.181 0 0 0-10.17-10.169z",
    transform: "translate(-13.195 -25.081)",
    style: {
      stroke: "#3e4346",
      strokeMiterlimit: 10,
      strokeWidth: "3.649px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2877",
    d: "m113.02 94.9-.006-.006a5.758 5.758 0 0 0-4.309-1.855H30.261l-3.013-10.023a5.482 5.482 0 0 0-5.342-3.688H5.539a5.027 5.027 0 1 0 0 10h12.13l15.369 51.182a5.486 5.486 0 0 0 5.342 3.685h57.969a5.477 5.477 0 0 0 5.34-3.687l12.359-41.149a4.657 4.657 0 0 0-1.028-4.459",
    transform: "translate(0 -12.208)",
    style: {
      fill: "#3e4346"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2878",
    d: "M113.624 110.461H30.493l6.7 22.331 3.489 11.62a2.437 2.437 0 0 0 2.389 1.487h57.968a2.419 2.419 0 0 0 2.382-1.487l2.977-9.906z",
    transform: "translate(-4.692 -16.998)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Pfad 2879",
    d: "m111.655 99.034-1.234 4.11H25.435L20.528 86.8H6.1a2.262 2.262 0 0 1-2.451-1.912 2.237 2.237 0 0 1 2.451-1.91h16.367a2.427 2.427 0 0 1 2.385 1.486l3.672 12.231h80.743a2.709 2.709 0 0 1 2.008.826 1.579 1.579 0 0 1 .38 1.514",
    transform: "translate(-.562 -12.769)",
    style: {
      fill: "#c5d75d"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGruppe2962);
export default __webpack_public_path__ + "static/media/gruppe-2962.efc36f37f79a48e57e5fce69b0595fe0.svg";
export { ForwardRef as ReactComponent };